import { Stack } from '@mui/material';
import StorageStatBlock, { StorageStatsEnum } from './StorageStatBlock';

const StorageStatsBlock = () => {
  return (
    <Stack direction="row" width="100%" spacing={3}>
      <StorageStatBlock type={StorageStatsEnum.SIZE} />
      <StorageStatBlock type={StorageStatsEnum.FILE_COUNT} />
      <StorageStatBlock type={StorageStatsEnum.FOLDER_COUNT} />
    </Stack>
  );
};

export default StorageStatsBlock;
